// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2bMdL","topBottomGutter":"Layout_topBottomGutter__1iV8N"};